var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseBigLight = function SvgCloseBigLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z",
    "data-name": "Rectangle 24561"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9492"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.375 21.997 2.002 2.625l.623-.623 19.372 19.373Z",
    "data-name": "Line 2179"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.625 21.997-.623-.623L21.375 2.002l.623.623Z",
    "data-name": "Line 2180"
  }))));
};
export { SvgCloseBigLight as ReactComponent };
export default "/_next/static/images/close-big-light.svg";